<template>
  <div class="na-shell">

    <!-- Ambient background blobs -->
    <div class="na-blob na-blob-1" />
    <div class="na-blob na-blob-2" />

    <!-- Dot-grid overlay -->
    <div class="na-grid" />

    <div class="na-card">

      <!-- Glow halo + icon -->
      <div class="na-icon-wrap">
        <div class="na-pulse" />
        <div class="na-glow" />
        <div class="na-icon-circle">
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
            <path d="M12 1C9.24 1 7 3.24 7 6v2H5a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V10a2 2 0 0 0-2-2h-2V6c0-2.76-2.24-5-5-5zm0 2c1.66 0 3 1.34 3 3v2H9V6c0-1.66 1.34-3 3-3zm0 9a2 2 0 1 1 0 4 2 2 0 0 1 0-4z"
              fill="url(#lock-grad)" />
            <defs>
              <linearGradient id="lock-grad" x1="0" y1="0" x2="24" y2="24" gradientUnits="userSpaceOnUse">
                <stop offset="0%" stop-color="#818cf8" />
                <stop offset="100%" stop-color="#6366f1" />
              </linearGradient>
            </defs>
          </svg>
        </div>
      </div>

      <!-- Label chip -->
      <div class="na-chip">
        <span class="na-chip-dot" />
        Access Restricted 
      </div>

      <!-- Heading + sub -->
      <div class="na-text">
        <h2 class="na-title">{{ title }}</h2>
        <p class="na-sub">{{ subtitle }}</p>
      </div>

      <!-- Divider -->
      <div class="na-divider" />

      <!-- Steps -->
      <!-- <div class="na-steps">
        <div class="na-step" v-for="(step, i) in steps" :key="i">
          <div class="na-step-num">{{ i + 1 }}</div>
          <span class="na-step-text">{{ step }}</span>
        </div>
      </div> -->

    </div>
  </div>
</template>

<script>
export default {
  name: 'NoAccessState',
  props: {
    title:    { type: String, default: 'Access Restricted' },
    subtitle: { type: String, default: "You don't have permission to view this page." },
    steps: {
      type: Array,
      default: () => [
        'Identify the module you need access to',
        'Reach out to your system administrator',
        'Wait for role or permission to be granted',
      ],
    },
  },
};
</script>

<style scoped>
/* ── Shell ── */
.na-shell {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 89vh;
  overflow: hidden;
  font-family: 'Inter', 'Roboto', sans-serif;
  background: #f5f6ff;
}

/* ── Ambient blobs ── */
.na-blob {
  position: absolute;
  border-radius: 50%;
  filter: blur(72px);
  pointer-events: none;
}
.na-blob-1 {
  width: 420px;
  height: 420px;
  background: radial-gradient(circle, rgba(99,102,241,.18) 0%, transparent 70%);
  top: -80px;
  left: -100px;
  animation: drift 10s ease-in-out infinite alternate;
}
.na-blob-2 {
  width: 320px;
  height: 320px;
  background: radial-gradient(circle, rgba(139,92,246,.14) 0%, transparent 70%);
  bottom: -60px;
  right: -80px;
  animation: drift 13s ease-in-out infinite alternate-reverse;
}
@keyframes drift {
  from { transform: translate(0, 0); }
  to   { transform: translate(30px, 20px); }
}

/* ── Dot grid ── */
.na-grid {
  position: absolute;
  inset: 0;
  background-image: radial-gradient(circle, #c7d2fe 1px, transparent 1px);
  background-size: 28px 28px;
  opacity: .35;
  pointer-events: none;
}

/* ── Card ── */
.na-card {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  padding: 48px 44px 40px;
  background: rgba(255,255,255,.92);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border: 1px solid rgba(199,210,254,.6);
  border-radius: 24px;
  box-shadow:
    0 0 0 1px rgba(99,102,241,.06),
    0 4px 6px rgba(0,0,0,.04),
    0 16px 48px rgba(99,102,241,.10);
  text-align: center;
  max-width: 420px;
  width: 100%;
}

/* ── Icon ── */
.na-icon-wrap {
  position: relative;
  width: 96px;
  height: 96px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.na-pulse {
  position: absolute;
  width: 96px;
  height: 96px;
  border-radius: 50%;
  background: rgba(99,102,241,.12);
  animation: pulse 2.4s ease-out infinite;
}
@keyframes pulse {
  0%   { transform: scale(.85); opacity: .7; }
  70%  { transform: scale(1.25); opacity: 0; }
  100% { transform: scale(1.25); opacity: 0; }
}

.na-glow {
  position: absolute;
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(99,102,241,.22) 0%, transparent 70%);
}

.na-icon-circle {
  position: relative;
  width: 60px;
  height: 60px;
  border-radius: 18px;
  background: linear-gradient(135deg, #eef2ff 0%, #e0e7ff 100%);
  border: 1.5px solid #c7d2fe;
  box-shadow: 0 4px 16px rgba(99,102,241,.2), inset 0 1px 0 rgba(255,255,255,.8);
  display: flex;
  align-items: center;
  justify-content: center;
}

/* ── Chip ── */
.na-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 14px;
  background: linear-gradient(135deg, #eef2ff, #e0e7ff);
  border: 1px solid #c7d2fe;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 700;
  color: #4338ca;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.na-chip-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #6366f1;
  box-shadow: 0 0 6px rgba(99,102,241,.7);
  animation: blink 1.8s ease-in-out infinite;
}
@keyframes blink {
  0%, 100% { opacity: 1; }
  50%       { opacity: .3; }
}

/* ── Text ── */
.na-text { display: flex; flex-direction: column; gap: 7px; }

.na-title {
  font-size: 18px;
  font-weight: 800;
  color: #111827;
  margin: 0;
  letter-spacing: -0.02em;
}

.na-sub {
  font-size: 13px;
  color: #6b7280;
  margin: 0;
  line-height: 1.7;
}

/* ── Divider ── */
.na-divider {
  width: 100%;
  height: 1px;
  background: linear-gradient(90deg, transparent, #e0e7ff 30%, #e0e7ff 70%, transparent);
}

/* ── Steps ── */
.na-steps {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  text-align: left;
}

.na-step {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 14px;
  background: #fafbff;
  border: 1px solid #eef2ff;
  border-radius: 10px;
}

.na-step-num {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: linear-gradient(135deg, #6366f1, #818cf8);
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.na-step-text {
  font-size: 12.5px;
  color: #374151;
  font-weight: 500;
  line-height: 1.4;
}
</style>
